const PERMISSION_KEY= "crm:user_info";
const PAGE_URL = {
    USER_INFO_PAGE: "/admin/crm/user-info"
}

export {PERMISSION_KEY, PAGE_URL}

